var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_52257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.043 140.871L180 226.957L46.9569 140.871V7.82776C46.8652 3.59729 50.2204 0.093914 54.4508 0.00220244C54.5616 1.3657e-06 54.6724 1.3657e-06 54.7832 0.00220244H305.217C309.447 -0.0895091 312.951 3.26567 313.043 7.49613C313.045 7.60692 313.045 7.71771 313.043 7.8285V140.871Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9563 140.871L0 109.567L46.9563 62.6104V140.871Z",
    fill: "#EFCFB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.999 109.567L313.043 140.871V62.6104L359.999 109.567Z",
    fill: "#F9E0CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.044 140.167L360 109.567V328.696C359.985 336.997 356.695 344.956 350.844 350.844L297.392 297.393L211.305 211.306L209.113 207.94L313.044 140.167Z",
    fill: "#FEEBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.39 297.392L350.842 350.844C344.954 356.695 336.995 359.985 328.694 360H31.3042C23.0032 359.985 15.0441 356.695 9.15625 350.844L62.6079 297.392L148.694 211.306L150.886 207.94L179.999 226.957L209.112 207.94L211.303 211.306L297.39 297.392Z",
    fill: "#EFCFB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.888 207.94L148.696 211.306L62.6101 297.392L9.15843 350.844C3.30724 344.956 0.016627 336.997 0.00195312 328.696V109.567L150.888 207.94Z",
    fill: "#FEEBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.702 253.896C203.557 259.031 235.164 235.75 240.299 201.895C245.435 168.041 222.153 136.433 188.299 131.298C154.444 126.163 122.837 149.444 117.702 183.299C112.567 217.153 135.848 248.761 169.702 253.896Z",
    fill: "#F79009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.438 192.437C241.438 226.537 213.538 254.437 179.438 254.437C159.675 254.437 142.238 245.525 131 231.188C141.463 239.713 155.025 244.75 169.75 244.75C203.85 244.75 231.75 216.85 231.75 182.75C231.75 168.025 226.713 154.463 218.188 144C232.525 155.237 241.438 172.675 241.438 192.437Z",
    fill: "#DB800A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69 159.155L184.044 207.289L171.707 205.418L177.691 156.88L192.69 159.155ZM174.603 227.925C172.379 227.588 170.588 226.511 169.231 224.697C167.878 222.859 167.381 220.83 167.741 218.609C168.053 216.403 169.125 214.635 170.959 213.304C172.793 211.973 174.823 211.476 177.047 211.814C179.182 212.138 180.939 213.209 182.318 215.027C183.697 216.845 184.231 218.857 183.92 221.063C183.672 222.542 183.073 223.842 182.121 224.962C181.196 226.063 180.07 226.892 178.744 227.45C177.422 227.985 176.041 228.143 174.603 227.925Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_52257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmEmail);
export default __webpack_public_path__ + "static/media/confirm-email.1fcbcee53961e598396f7fea4d4f48c8.svg";
export { ForwardRef as ReactComponent };